import {
    GET_PRICE_TYPES, ADD_PRICE_TYPE, PRICE_TYPE_ERROR
} from '../actions/types';


const initialState = { price_types: [], price_type: null, loading: true, error: {} }

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_PRICE_TYPES:
            return {
                ...state,
                price_types: payload,
                loading: false
            }
        case ADD_PRICE_TYPE:
            return {
                ...state,
                price_types: [...state.price_types, payload],
                loading: false
            }
        case PRICE_TYPE_ERROR:
            return {
                ...state,
                error: payload,
                loading: false
            }
        default:
            return state;
    }

}